module.exports = __webpack_public_path__ + "img/lightning.80da5992.png";